import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-navbar-wrapper',
  templateUrl: './navbar-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./navbar-wrapper.component.scss'],
})
export class NavbarWrapperComponent {}
